import { configure, extend } from "vee-validate";
import {
  confirmed,
  email,
  integer,
  regex,
  required,
} from "vee-validate/dist/rules";
import i18n from "./i18n/i18n";
import { isValidPhone } from "./utils/phone";

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = i18n.t(`fields.${field}`);

    return i18n.t(`validations.messages.${values._rule_}`, values);
  },
});

// Import rules
extend("email", email);
extend("regex", regex);
extend("integer", integer);
extend("confirmed", confirmed);
extend("required", required);

// Add custom rules.
extend("time-validation", {
  validate: (value) => {
    return !!value && /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(value);
  },
  computesRequired: true,
  message: () => i18n.t("validation.timeformat"),
});
extend("phone-validation", {
  validate: (value) => {
    return isValidPhone(value);
  },
  message: () => i18n.t("validation.phoneformat"),
});
extend("email-validation", {
  validate: (value) => {
    return (
      !!value &&
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
        value
      )
    );
  },
  message: () => i18n.t("validation.emailformat"),
});
extend("time-overlap-from", {
  validate(value, args) {
    if (value > args.hours.date) {
      return false;
    }
    return args.hours.openHours.every((hour) => {
      return value <= hour.from || value >= hour.to;
    });
  },
  params: ["hours"],
  message: () => i18n.t("validation.timeoverlap.from"),
});
extend("time-overlap-to", {
  validate(value, args) {
    if (value < args.hours.date) {
      return false;
    }
    return args.hours.openHours.every((hour) => {
      if (args.hours.date <= hour.from) {
        return value <= hour.from;
      }
      if (args.hours.date >= hour.to) {
        return value >= hour.to;
      }
    });
  },
  params: ["hours"],
  message: () => i18n.t("validation.timeoverlap.to"),
});



// WEBPACK FOOTER //
// ./src/vee-validate.js